import React from "react";
import { Field, ErrorMessage } from "formik";
import { Plan } from "../dataTypes";

interface PlanDetailsTabProps {
  values: Plan;
  onNext: () => void;
}

const PlanDetailsTab: React.FC<PlanDetailsTabProps> = ({ values, onNext }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Plan Title *
          </label>
          <Field
            name="title"
            type="text"
            className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors"
            placeholder="e.g., Professional Plan, Enterprise Suite"
          />
          <ErrorMessage name="title" component="div" className="text-red-500 text-sm mt-2" />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Description *
          </label>
          <Field
            as="textarea"
            name="description"
            rows={4}
            className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors resize-none"
            placeholder="Describe the features and benefits of this plan..."
          />
          <div className="flex justify-between text-sm text-gray-500 dark:text-gray-400 mt-2">
            <ErrorMessage name="description" component="span" className="text-red-500" />
            <span>{values.description.length}/500</span>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-6 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          onClick={onNext}
          className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl transition-colors duration-200 shadow-sm hover:shadow-md"
        >
          Continue to Pricing & Limits
        </button>
      </div>
    </div>
  );
};

export default PlanDetailsTab;